// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.94.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.94.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sunzi__variant-TxROo {
  padding: 18px 0 6px 0 !important;
}
.sunzi__variant-TxROo .variant-title {
  font-size: 16px !important;
  color: rgba(0, 0, 0, 0.88) !important;
  padding: 0 0 8px 0 !important;
}
.sunzi__variant-TxROo .variant-title {
  line-height: 22px;
}
.sunzi__color-variants-fP3n1 {
  padding: 16px 0 0 0 !important;
}
.sunzi__color-variants-fP3n1 .variant-title {
  font-size: 12px !important;
  color: #000000 !important;
}
.sunzi__color-variants-fP3n1 .variant-title {
  line-height: 14px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/style.module.less"],"names":[],"mappings":"AAAA;EACE,gCAAA;AACF;AAFA;EAIM,0BAAA;EAEA,qCAAA;EACA,6BAAA;AACN;AARA;EAKM,iBAAA;AAGN;AAGA;EACE,8BAAA;AADF;AAAA;EAIM,0BAAA;EAEA,yBAAA;AADN;AALA;EAKM,iBAAA;AAAN","sourcesContent":[".variant {\n  padding: 18px 0 6px 0 !important;\n  :global {\n    .variant-title {\n      font-size: 16px !important;\n      line-height: 22px;\n      color: rgba(0, 0, 0, 0.88) !important;\n      padding: 0 0 8px 0 !important;\n    }\n  }\n}\n.color-variants {\n  padding: 16px 0 0 0 !important;\n  :global {\n    .variant-title {\n      font-size: 12px !important;\n      line-height: 14px;\n      color: #000000 !important;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"variant": `sunzi__variant-TxROo`,
	"color-variants": `sunzi__color-variants-fP3n1`,
	"colorVariants": `sunzi__color-variants-fP3n1`
};
export default ___CSS_LOADER_EXPORT___;
